import { Inject, Injectable } from '@angular/core';
import { NavigatorBannerState } from './navigator-banner.state';
import { ISmartNavigatorService, SMART_NAVIGATOR_SERVICE } from '@ui-tool/core';
import { NavigatorBaseComponentStore } from '../base';
import {
  NavigatorContainerCodes,
  ScreenCodes,
} from '@mobile-data-access-enums';
import { NavController } from '@ionic/angular';

@Injectable()
export class NavigatorBannerComponentStore extends NavigatorBaseComponentStore<
  NavigatorContainerCodes.BANNER,
  NavigatorBannerState
> {
  //#region Constructor

  public constructor(
    @Inject(SMART_NAVIGATOR_SERVICE)
    protected override readonly _navigationService: ISmartNavigatorService,
    protected override readonly _navController: NavController
  ) {
    super(_navigationService, _navController, ScreenCodes.CHEMOTHERAPY);
  }

  //#endregion
}
